import { displayError } from "@app/init/displayError";
import { ERRORS_MARKED_AS_HANDLED } from "./sentry/SentryErrors";

/**
 * Display errors caught before ServiceSentry get initialized
 */
export function initBasicErrorBox() {
	const onErrorShowBox = (errorEvent: ErrorEvent) => {
		const errorMessage = errorEvent.error?.reason || errorEvent.message || "Undefined error";
		if (ERRORS_MARKED_AS_HANDLED.some(message => errorMessage.includes(message))) {
			// do not show modal for 'handled' errors
			return;
		}
		displayError(errorMessage, { showReloadButton: true });
	};

	const onUnhandledExceptionShowBox = (error: PromiseRejectionEvent) => {
		const errorMessage = error.reason?.message || "Undefined promise rejection";
		if (ERRORS_MARKED_AS_HANDLED.some(message => errorMessage.includes(message))) {
			// do not show modal for 'handled' errors
			return;
		}
		displayError(error.reason || "Undefined promise rejection", { showReloadButton: true });
	};

	window.addEventListener("error", onErrorShowBox);
	window.addEventListener("unhandledrejection", onUnhandledExceptionShowBox);

	// the basic error box will be deactivated on target ErrorMessage view initialization
	window.cleanBasicErrorBoxHandlers = () => {
		window.removeEventListener("error", onErrorShowBox);
		window.removeEventListener("unhandledrejection", onUnhandledExceptionShowBox);
		delete window.cleanBasicErrorBoxHandlers;
	};
}